module.exports = require("zlib");


//////////////////
// WEBPACK FOOTER
// external "zlib"
// module id = 81
// module chunks = 0 1 2 3 4 5 6 7 10 11